/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Commentable types.
 * @export
 */
export const InternalCommonCommentableTypes = {
    AdminEvent: 'admin_event',
    Article: 'article',
    Comment: 'comment',
    ForumDiscussion: 'forum_discussion',
    Location: 'location',
    MediaCenterFile: 'media_center_file',
    News: 'news',
    Opportunity: 'opportunity',
    Post: 'post',
    Project: 'project',
    User: 'user',
    UserEvent: 'user_event'
};
export function instanceOfInternalCommonCommentableTypes(value) {
    for (const key in InternalCommonCommentableTypes) {
        if (Object.prototype.hasOwnProperty.call(InternalCommonCommentableTypes, key)) {
            if (InternalCommonCommentableTypes[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function InternalCommonCommentableTypesFromJSON(json) {
    return InternalCommonCommentableTypesFromJSONTyped(json, false);
}
export function InternalCommonCommentableTypesFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function InternalCommonCommentableTypesToJSON(value) {
    return value;
}
export function InternalCommonCommentableTypesToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
